











import Vue from 'vue'
import {Component, Prop, Watch} from "vue-property-decorator";

@Component
export default class Tags extends Vue{
  @Prop(Array) readonly tags: string[] | undefined;
  @Prop(String) readonly defaultTag!: string;

  currentTagIndex = 0;
  currentTagName = this.defaultTag;

  selectedTag(index: string, tag: string){
    this.currentTagIndex = parseInt(index);
    this.currentTagName = tag;
  }
  createTag(){
    const tagName = window.prompt('请输入新的标签名');
    if (tagName === '' || tagName === null) {
      window.alert('标签名不能为空');
    } else if (this.tags?.includes(tagName!)){
      window.alert('标签名已存在');
    }else if (this.tags) {
      this.$emit('update:tags', [...this.tags, tagName]);
    }
  }

  @Watch('currentTagName')
  onTagChanged(newTag: string){
    this.$emit('update:defaultTag',newTag);
  }
}
